/* ------------------------- External Dependencies -------------------------- */
import React from 'react'

/* ------------------------- Internal Dependencies -------------------------- */
import {
  Box
} from 'atomic'
/* ------------------------------- Component -------------------------------- */
export default props => 
<Box>

</Box>


// WEBPACK FOOTER //
// ./src/interface/containers/ethers/EthersGanacheConnect/component/index.js